import React from 'react';
import PropTypes from 'prop-types';
import { isUndefined } from 'lodash';
import classnames from 'classnames';
import { NavLink } from '@src/components/Link';
import './styles.scss';

export default function TabNavigation({
  numbered,
  active,
  wrapperClassName,
  index,
  label,
  path,
  to,
  params,
  onClick,
  disabled,
}) {
  const tabClassName = classnames(
    'ewc-tabnav',
    wrapperClassName,
    { 'ewc-tabnav--active': active },
    { 'ewc-tabnav--numbered': numbered },
    { 'ewc-tabnav--disabled': disabled },
  );

  const number = numbered ? (
    <div className={classnames('ewc-tabnav__number', { 'ewc-tabnav__number--active': active })}>{index + 1}</div>
  ) : null;

  const labelEl = (
    <div className="ewc-tabnav__label">
      {number} {label}
    </div>
  );

  if (to && labelEl !== undefined) {
    const additionalProps = isUndefined(active) ? {} : { isActive: () => active };
    return (
      <NavLink
        activeClassName="ewc-tabnav--active"
        className={classnames('ewc-tabnav', { 'ewc-tabnav--numbered': numbered }, { 'ewc-tabnav--disabled': disabled })}
        onClick={onClick}
        params={params}
        to={to}
        {...additionalProps}
        exact
      >
        {labelEl}
      </NavLink>
    );
  }

  if (path) {
    return (
      <a className={tabClassName} href={path} target="_top">
        {labelEl}
      </a>
    );
  }

  return (
    <div className={tabClassName} onClick={onClick}>
      {labelEl}
    </div>
  );
}

TabNavigation.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  index: PropTypes.number.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  numbered: PropTypes.bool,
  onClick: PropTypes.func,
  params: PropTypes.object,
  path: PropTypes.string,
  to: PropTypes.string,
  wrapperClassName: PropTypes.string,
};
